import styled from 'styled-components'
import { colors, fonts } from 'client/styles'

export const FilterFacilitiesBase = styled.div`
  padding-block: 15px;
  padding-inline: 20px;
`

export const Title = styled.h3`
  color: ${colors.grey1};
  font-weight: 700;
  margin-block-end: 1rem;
`

export const List = styled.ul`
  padding-block: 0;
  padding-inline: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
`

export const Item = styled.li`
  margin-block: 0.25rem;
  margin-inline: 0.25rem;
  max-width: 100%;

  &:last-of-type {
    /* fixes flexbox flow (see comments https://bitbucket.org/stay4longdev/web-stayforlong/pull-requests/1301/stay-4467-fixes-broken-facilities-layout/diff?w=1) */
    max-width: 97%;
  }
`

export const Label = styled.label`
  background-color: ${props => (props.selected ? colors.magenta2 : colors.white)};
  border: 2px solid ${props => (props.selected ? colors.magenta : colors.grey4)};
  border-radius: 60px;
  color: ${props => (props.selected ? colors.magenta : colors.grey2)};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: ${fonts.default};
  padding-block: 6px;
  padding-inline: 15px;
  width: auto;
  white-space: nowrap;
  justify-content: center;
  font-size: 14px;

  &:focus {
    outline: none;
  }

  svg {
    fill: ${props => (props.selected ? colors.magenta : colors.grey2)};
    margin-inline-end: 10px;
    width: 18px;
  }
`

export const FacilityText = styled.span`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Checkbox = styled.input`
  /* Styles to hide checkbox */
  border: 0;
  clip-path: inset(50%);
  clip: rect(0 0 0 0);
  height: 1px;
  margin-block: -1px;
  margin-inline: -1px;
  overflow: hidden;
  padding-block: 0;
  padding-inline: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const Pill = styled.span`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  background-color: ${colors.blue};
  width: 100%;
  height: 100%;
  z-index: var(--z-behind);

  ${Checkbox}:checked + & {
    background-color: ${colors.grey1};
  }
`
